// extracted by mini-css-extract-plugin
export default {"MatchSuggestionItem":"MatchSuggestionItem_MatchSuggestionItem__6ozES","match":"MatchSuggestionItem_match__wCE+H","date":"MatchSuggestionItem_date__dyIjH"};